<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
         :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="column is-12 pdb-0" v-if="newCritereRecherche.faceIds.length > 0 && face">
        <qd-notification type="is-primary"
                        class="is-marginless pd-6px" @close="deleteFaceId()">
          {{ $t('listeOrdreTravailTech.filtre.face', { face: face.code }) }}
        </qd-notification>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOrdreTravailTech.filtre.code')">
          <qd-taginput v-model="newCritereRecherche.codes" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeOrdreTravailTech.filtre.etat')"
                      :items="constantes.LIST_ETAT_OT_TECH"
                      v-model="etatsSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0" v-if="afficherProjetDossier">
        <b-field :label="$t('listeOrdreTravailTech.filtre.projet')">
          <qd-taginput
            v-model="projetSelected"
            icon="magnify"
            :data="projets"
            autocomplete
            type="is-primary"
            :loading="isFetching"
            field="libelle"
            @typing="getProjet">
            <template slot-scope="props">
              {{ props.option.libelle }}
            </template>
            <template slot="empty">
              <div v-if="!isFetchingProjet">
                {{$t('general.autocomplete.noRslt')}}
              </div>
              <div v-else>
                {{$t('general.autocomplete.search')}}
              </div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0" v-if="afficherProjetDossier">
        <b-field :label="$t('listeOrdreTravailTech.filtre.dossier')">
          <qd-taginput
            v-model="dossierSelected"
            icon="magnify"
            :data="dossiers"
            autocomplete
            type="is-primary"
            :loading="isFetching"
            field="libelle"
            @typing="getDossier">
            <template slot-scope="props">
              {{ props.option.libelleDossierProjet }}
            </template>
            <template slot="empty">
              <div v-if="!isFetchingDossier">
                {{$t('general.autocomplete.noRslt')}}
              </div>
              <div v-else>
                {{$t('general.autocomplete.search')}}
              </div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOrdreTravailTech.filtre.dateSouhaite')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.dates.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('general.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.dates.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOrdreTravailTech.filtre.datePlanification')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datesPremierAffichage.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('general.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datesPremierAffichage.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOrdreTravailTech.filtre.dateRealisation')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datesValidite.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('general.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datesValidite.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>

      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOrdreTravailTech.filtre.dateFacture')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datesFacture.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('general.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="newCritereRecherche.datesFacture.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOrdreTravailTech.filtre.type')">
          <qd-taginput v-if="typeTags"
                      v-model="typeSelected"
                      :data="typeTags"
                      type="is-primary"
                      autocomplete
                      icon="magnify"
                      open-on-focus
                      field="libelle"
                      @typing="getFilteredTypeTags"
                      @input="getTypeTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOrdreTravailTech.filtre.codeFacture')">
          <qd-taginput v-model="newCritereRecherche.codesFacture" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOrdreTravailTech.filtre.technicien')">
          <qd-taginput
            v-model="technicienSelected"
            icon="magnify"
            :data="techniciens"
            autocomplete
            type="is-primary"
            :loading="isFetching"
            field="nomCommercial"
            @typing="getTechnicien">
            <template slot-scope="props">
              {{ props.option.nomCommercial }}
            </template>
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('general.autocomplete.noRslt')}}
              </div>
              <div v-else>
                {{$t('general.autocomplete.search')}}
              </div>
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOrdreTravailTech.filtre.adresse')">
          <b-input v-model="newCritereRecherche.adresse">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOrdreTravailTech.filtre.ville')">
          <ville-tag-input-auto-complete
            :critere-recherche="newCritereRecherche"
            table-name="Emplacement"/>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOrdreTravailTech.filtre.codePostal')">
          <qd-taginput v-model="newCritereRecherche.codesPostaux"
                      type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input
                      :label="$t('listeOrdreTravailTech.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="newCritereRecherche.agencesId">
        </agence-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeOrdreTravailTech.filtre.facture')">
          <b-select v-model="newCritereRecherche.facture">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }} </option>
            <option :value="false"> {{ $t('general.non') }} </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('listeOrdreTravailAffichage.filtre.actions.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('listeOrdreTravailAffichage.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import genererCritereRecherche
  from '@/services/logistique/ordreTravail/tech/genererObject/genererCritereRecherche';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import {
  LIST_ETAT_OT_TECH,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import { SET_CRITERES } from '@/store/modules/logistique/ordreTravailTech-mutation-type';
import validationCriteresRecherche
  from '@/services/logistique/ordreTravail/tech/validation/validationCritereRecherche';
import { getAll } from '@/api/tiers/index';
import { TIERS_TYPE_FOURNISSEUR, TIERS_SOUS_TYPE_TECHNICIEN } from '@/configuration/tiers/tiersConf';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { getAll as getAllProjet } from '@/api/logistique/projets/index';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import { get } from '@/api/gabed/face';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';

const Parametres = createNamespacedHelpers('parametres');
const OT = createNamespacedHelpers('ordreTravailTech');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      newCritereRecherche: null,
      constantes: {
        LIST_ETAT_OT_TECH,
      },
      etatsSelected: [],
      errors: [],
      typeTags: null,
      typeSelected: [],
      typeBase: [],
      isFetching: false,
      techniciens: [],
      technicienSelected: [],
      isFetchingProjet: false,
      projets: [],
      projetSelected: [],
      isFetchingDossier: false,
      dossiers: [],
      dossierSelected: [],
      listeCommercialBase: null,
      face: null,
    };
  },
  components: {
    libelleTagInput,
    agenceTagInput,
    errorMsgComponent,
    VilleTagInputAutoComplete,
  },
  computed: {
    ...OT.mapGetters({
      critereRechercheFromStore: 'critereRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    types() {
      return this.parametre(PARAMETRES_KEYS.typeOt);
    },
    afficherProjetDossier() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.afficherProjetDossierLogistiqueTechnique
        .key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...OT.mapMutations({
      setCritereRecherche: SET_CRITERES,
    }),
    deleteFaceId() {
      this.newCritereRecherche.faceIds = [];
      this.face = null;
    },
    getTechnicien: debounce(async function technicienData(text) {
      try {
        this.techniciens = [];
        this.isFetching = true;
        const techniciens = (await getAll({
          query: {
            auto: text,
            societeId: this.societeActiveId,
            type: TIERS_TYPE_FOURNISSEUR,
            sousType: [TIERS_SOUS_TYPE_TECHNICIEN],
          },
          limit: NO_PAGINATION,
        })).data.result.items;
        this.techniciens = techniciens.filter((tech) => {
          return !this.technicienSelected.map(
            techSelect => techSelect.id,
          ).includes(tech.id);
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
    getProjet: debounce(async function projetData(text) {
      try {
        this.projets = [];
        this.isFetchingProjet = true;
        this.projets = (await getAllProjet({
          query: {
            libelle: text,
            societeId: this.societeActiveId,
            archive: false,
          },
          limit: NO_PAGINATION,
        })).data.result.items;
        this.isFetchingProjet = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingProjet = false;
        throw e;
      }
    }, 500),
    getDossier: debounce(async function dossierData(text) {
      try {
        this.dossiers = [];
        this.isFetchingDossier = true;
        const projet = (await getAllProjet({
          query: {
            libelleDossier: text,
            societeId: this.societeActiveId,
            archive: false,
          },
          limit: NO_PAGINATION,
        })).data.result.items;
        projet.forEach((projet) => {
          if (!projet.dossiers.length) return;
          projet.dossiers.forEach((dossier) => {
            this.dossiers.push({
              libelle: dossier.libelle,
              libelleDossierProjet: projet.libelle + ' - ' + dossier.libelle,
              id: dossier.id,
            });
          });
        });
        this.isFetchingDossier = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingProjet = false;
        throw e;
      }
    }, 500),
    appliquerCritere() {
      this.errors = [];
      validationCriteresRecherche(this.newCritereRecherche, this.errors);
      if (this.errors.length !== 0) return;
      this.newCritereRecherche.otEtat = this.etatsSelected.map(el => { return el.code; });
      this.newCritereRecherche.typesOt = this.typeSelected.map(el => { return el.id; });
      this.newCritereRecherche.tiers = this.technicienSelected;
      this.newCritereRecherche.dossiers = this.dossierSelected;
      this.newCritereRecherche.projets = this.projetSelected;
      this.setCritereRecherche(this.newCritereRecherche);
      this.$emit('recherche', this.newCritereRecherche);
    },
    viderCritere() {
      this.etatsSelected = [];
      this.typeSelected = [];
      this.technicienSelected = [];
      this.dossierSelected = [];
      this.projetSelected = [];
      this.newCritereRecherche = genererCritereRecherche();
      this.getTypeTag();
    },
    getFilteredTypeTags(text) {
      this.getTypeTag();
      this.typeTags = this.typeTags.filter((type) => {
        return type.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getTypeTag() {
      this.typeTags = this.typeBase.filter((type) => {
        return !this.typeSelected.map(a => a.id).includes(type.id);
      });
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.getTechnicien();
        await this.getProjet();
        await this.loadParametres([PARAMETRES_KEYS.typeOt]);
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.afficherProjetDossierLogistiqueTechnique.key]);
        this.newCritereRecherche = cloneDeep(this.critereRechercheFromStore);
        this.technicienSelected = this.newCritereRecherche.tiers;
        this.projetSelected = this.newCritereRecherche.projets;
        this.dossierSelected = this.newCritereRecherche.dossiers;

        if (this.newCritereRecherche.otEtat.length > 0) {
          this.etatsSelected = this.constantes.LIST_ETAT_OT_TECH.filter((e) => {
            return this.newCritereRecherche.otEtat.includes(e.code);
          });
        }

        this.typeBase = this.types;
        if (this.newCritereRecherche.typesOt) {
          this.typeSelected = this.typeBase.filter((t) => {
            return this.newCritereRecherche.typesOt.includes(t.id);
          });
        }
        this.getTypeTag();

        if (this.newCritereRecherche.faceIds.length > 0) {
          this.face = (await get(this.newCritereRecherche.faceIds[0])).data.result;
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};

</script>
